<template>
  <div class="text-right" dir="rtl">
    <div class="">
      <div class="my-3">پنل های کاربر</div>
      <div class="form-check form-check-inline" v-for="panel in panels">
        <input v-model="panelValue" @click="selectedValue(panel.id)" class="form-check-input" type="radio" name="panels"
               :id="`panel-${panel.id}`"
               :value="panel.id">
        <label class="form-check-label mx-1" :for="`panel-${panel.id}`">{{ panel.name }}</label>
      </div>
      <button type="button" v-if="panelValue != null " @click="removeUserPanels" class="btn btn-danger btn-sm">حذف
        دسترسی به پنل
      </button>


    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "PanelManager",
  props: {
    user: {}
  },
  data() {
    return {
      panelValue: null
    }
  },
  computed: {
    ...mapGetters({
      panels: "Language/getPanels"
    })
  },
  methods: {
    setPanelsValues() {
      // set panel values
      if (this.user != undefined) {
        this.user.panels.forEach(item => {
          this.panelValue = item.language_id
          this.user.panels = this.panelValue
        })
      }
      return null
    },
    selectedValue(value) {
      this.user.panels = value
    },
    removeUserPanels() {
      let form = {
        user_id: this.user.id
      }

      this.$store.dispatch('User/removeUserPanel', form).then(res => {
        this.user.panels = null
        this.panelValue = null
      })

    }

  },
  watch: {
    user: {
      handler: function (val, oldVal) {
        if (val.panels != undefined) {
          this.setPanelsValues()
        }
      },
    },
  }

}
</script>


<style scoped>

</style>